angular.module('unergie.main')
.directive('userInfoAccountFsl', ($uibModal, $filter, AlertManager, BoFeaturesService, ModalService, PaymentService, MetaWatcher, ContractService, ErrorCatcher) =>
    ({
        restrict: 'E',
        templateUrl: '/states/userContractInfo/component/account/userInfoAccountFsl.html',
        link($scope) {
            const feats = BoFeaturesService.getModuleFeatures('accountinfo')
            $scope.isAIFeatureOn = (feature) => feats[feature]
            $scope.selectedContract = null
            $scope.spinners = {}

            $scope.openFSLModal = () => ModalService.openModal({ type: 'fslModal', size: 'md' }, { account: $scope.account, fsl: null }, $scope.refreshAccount)

            $scope.openFSLHistoryModal = () => ModalService.openModal({ type: 'fslHistoryModal', size: 'lg' }, { account: $scope.account })

            $scope.openFslResponseModal = () => ModalService.openModal({ type: 'fslModal', size: 'md' }, { account: $scope.account, fsl: $scope.actualRequest }, $scope.refreshAccount)

            const computeFsls = () => {
                $scope.nbFsls = $scope.account.fsls.length
                $scope.actualRequest = _.find($scope.account.fsls, { status: 'REQUESTED' })
            }

            computeFsls()

            $scope.$watch('account', computeFsls)

            ContractService.watch('userInfoAccountFSL', (selectedContract) => {
                $scope.selectedContract = selectedContract
            })
        },
    })
)
